export const ACTIVITY_LOG_PAGE_SIZE = 50;

// Keep in step with the `limit` cap on GET /api/activity-log/ (le=500): asking for more is a 422
// and the whole page turns into an error.
export const ACTIVITY_LOG_MAX_LIMIT = 500;

export const nextActivityLogLimit = (limit) =>
  Math.min(limit + ACTIVITY_LOG_PAGE_SIZE, ACTIVITY_LOG_MAX_LIMIT);

// A full page means there may be more rows to fetch.
export const canLoadMoreActivity = (shown, limit) =>
  shown >= limit && limit < ACTIVITY_LOG_MAX_LIMIT;

// The newest ACTIVITY_LOG_MAX_LIMIT rows are showing and the list is still full: older rows exist
// but cannot be reached by loading more; the filters are the way to narrow down.
export const hitActivityLogCeiling = (shown, limit) =>
  shown >= limit && limit >= ACTIVITY_LOG_MAX_LIMIT;
